module.exports = __webpack_public_path__ + "images/interview-Capital_one-2.svg";